import React from 'react';
import { Skeleton } from '../../shared/Skeleton';
import ClientDetailLayout from './ClientDetailLayout';
import ClientHeader from './ClientHeader';
import { SURFACE } from '../layout';

// The loading shape of the whole page: the same four zones as the loaded page, so
// nothing shifts when data arrives. One role="status" for assistive tech — the
// blocks inside are decorative.

const Card = ({ lines = 3, className = '' }) => (
  <div className={`${SURFACE} ${className}`} aria-hidden="true">
    <Skeleton className="h-5 w-40" />
    <div className="mt-4 space-y-2.5">
      {Array.from({ length: lines }).map((_, i) => <Skeleton key={i} className="h-10" />)}
    </div>
  </div>
);

export default function ClientDetailSkeleton() {
  return (
    <div role="status" aria-label="Loading">
      <ClientDetailLayout
        header={<ClientHeader loading facts={null} />}
        strip={<div className={SURFACE} aria-hidden="true"><div className="flex flex-wrap gap-3"><Skeleton className="h-11 w-56 rounded-xl" /><Skeleton className="h-11 w-64 rounded-xl" /><Skeleton className="h-11 w-48 rounded-xl" /></div></div>}
        main={<><Card lines={4} /><Card lines={2} /></>}
        rail={<Card lines={4} />}
        activity={<Card lines={4} />}
      />
      <span className="sr-only">Loading…</span>
    </div>
  );
}

